<dialog-draggable-header>
   NEC Reports for {{this.fixture.fixtureNo}}
</dialog-draggable-header>

<mat-dialog-content>
   <div *ngIf="hasLoaded" class="h-100">
      <div *ngIf="(this.necData$ | async) as data" class="h-100">
         <data-table #tprGrid [data]="this.necData$ | async" [columns]="columns" [filterColumnDisplay]="false"
            [lazy]="true" [loading]="loading" (select)="necLecSelected($event)">
            <ng-container actionStart featurePermission="ecm">
               <button subFeaturePermission="nec" mat-button class="m-1" type="button" (click)="onReportclick()"
                  (keydown.enter)="onReportclick()">
                  Preview/Print/File Report
               </button>
            </ng-container>
            <ng-container actionEnd>
               <button mat-button class="m-1" mat-dialog-close type="button" (keypress)="cancel()"
                  (click)="cancel()">Cancel</button>
            </ng-container>
         </data-table>
      </div>
   </div>
</mat-dialog-content>